import { TableCellsIcon } from "@heroicons/react/24/outline";
import type { ComponentType, SVGProps } from "react";
import { DASHBOARD_ROUTES } from "../../../config/routes";

export interface PlaceLink {
  label: string;
  to: string;
  icon?: ComponentType<SVGProps<SVGSVGElement>>;
}

export const getPlaceImage = (place: Place) =>
  place?.logoImage ||
  place?.image ||
  `https://ui-avatars.com/api/?name=${encodeURIComponent(place?.name ?? "")}`;

/** Links shown in the "Contenu complémentaire" modal */
export const getPlaceMoreLinks = (place: Place): PlaceLink[] => [
  { label: "Factures", to: `/places/${place.id}/invoices` },
  {
    label: "Paiement",
    to: `${DASHBOARD_ROUTES.payment.list({ place: place.id })}`,
  },
  { label: "Services", to: `/places/${place.id}/services` },
  { label: "Galerie", to: `/places/${place.id}/gallery` },
  { label: "Commentaires", to: `/places/${place.id}/ratings` },
  { label: "Inspecteurs", to: `/places/${place.id}/inspectors` },
  ...(place.supportTableSelection
    ? [
        {
          label: "Plans de tables",
          to: `/places/${place.id}/planner`,
          icon: TableCellsIcon,
        },
      ]
    : []),
];